// Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { ThemeProvider } from "@emotion/react";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import store from "./store/store";
import { lightTheme, darkTheme } from "./styles/theme";
import ConnectorInfo from "./pages/ConnectorInfo";
import { APP_NAME, GOOGLE_ANALYTICS_ID } from "./utils/constants";
import ReactGA from "react-ga4";

const App: React.FC = () => {
  // a.initialize(GOOGLE_ANALYTICS_ID);

  const [darkMode, setDarkMode] = useState(false);

  const handleThemeChange = (isDark: boolean) => {
    setDarkMode(isDark);
  };

  return (
    <Provider store={store}>
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <BrowserRouter>
          <Box className="App">
            <NavBar appName={APP_NAME} onThemeChange={handleThemeChange} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/connector/:id" element={<ConnectorInfo />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Box>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
